var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "video-content" },
    [_c("headerItem"), _vm._v(" "), _c("uploaderRecommend")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }